import React from 'react'
import { Box, Button, Card, CardBody, CardFooter, Heading, Stack, Text, useColorMode } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import RichContent from '../../uielements/RichContent/richContent'
import CustomImage from '../../uielements/Image'
import { Link } from 'gatsby'
import { useTranslation } from 'react-i18next'
import { localisedLink } from '../../utils/utils'
import { POST_SLUG } from '../../lib/constants'

const PostItem = ({ title, slug, featuredImage, excerpt, published, minW, maxW, margin }) => {
    const { colorMode } = useColorMode()
    const { i18n, t } = useTranslation()

    return (
        <Card borderRadius={30} border={'2px solid'} minW={minW} maxW={maxW} m={margin}>
            <CardBody p={0}>
                <Box height={300} borderRadius={30} overflow={'hidden'}>
                    <Link to={localisedLink(i18n.language, POST_SLUG, slug)}>
                        <Box
                            height={300}
                            transition={'all 0.7s ease'}
                            _hover={{
                                transform: 'scale(1.3)',
                            }}
                        >
                            <CustomImage obj={featuredImage} borderRadius={28} fit={'cover'} />
                        </Box>
                    </Link>
                </Box>
                <Box
                    bgColor={colorMode === 'dark' ? 'brand.darkBg' : 'white'}
                    zIndex={3}
                    borderTopRightRadius={30}
                    borderTopLeftRadius={30}
                    mt={'-40px'}
                    position={'relative'}
                    transition={'all 0.3s ease'}
                    _hover={{
                        mt: '-120px',
                        paddingBottom: '80px',
                    }}
                >
                    <Stack spacing="3" p={4} position={'relative'}>
                        <Text fontSize={'sm'}>{published}</Text>
                        <Heading size="md" noOfLines={3}>
                            {title}
                        </Heading>
                        <Box noOfLines={[3, 4]} lineHeight={7}>
                            <RichContent body={excerpt} locale={i18n.language} />
                        </Box>
                    </Stack>
                </Box>
            </CardBody>
            <CardFooter p={4}>
                <Button spacing="2">
                    <Link to={localisedLink(i18n.language, POST_SLUG, slug)}>{t('read-more-capital')}</Link>
                </Button>
            </CardFooter>
        </Card>
    )
}

PostItem.propTypes = {
    title: PropTypes.string,
    slug: PropTypes.string,
    published: PropTypes.string,
    margin: PropTypes.number,
    minW: PropTypes.array,
    maxW: PropTypes.array,
}

PostItem.defaultProps = {
    minW: ['280px'],
    maxW: ['320px'],
    margin: 2,
}

export default PostItem
